module.exports = "<img ng-if=\"$ctrl.model.media.type === 'image'\" ng-src=\"{{ $ctrl.previewImage }}\" alt=\"image\"/>\n<div>\n    <a class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.onRemove()\">\n        <em class=\"ion-trash-a\"></em>\n    </a>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/MediaModules/HasMediaTile/has-media-tile.html
// module id = 1086
// module chunks = 0